module.exports = __webpack_public_path__ + "img/img33.fd63c2a5.svg";